const en = {
  ADMINISTRATOR: "Administrator",
  PROJECTMANAGER: "Advanced User",
  STANDARDUSER: "Project Team"
};

export default en;
